import * as react from "react";
import { ofArray, singleton as singleton_1, empty, map, toArray, length, isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { toString } from "../../../fable_modules/fable-library-js.4.19.0/Date.js";
import { adminImageUploadBox, validatedTextarea, checkbox, validatedDatePicker, validatedTextBox, pagination, errorMsg, spinner, icon } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { NewsModel__get_CanSubmit, Filter, Msg, Page } from "./Types.fs.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { DangerousHtml, DOMAttr, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { int32ToString, equals } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Option, ISize, column } from "../../../fable_modules/Fulma.3.0.0/Layouts/Column.fs.js";
import { Screen } from "../../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { Selector } from "../../../KundenTypSelector.fs.js";
import { MultiSelector } from "../../../BundeslandSelector.fs.js";
import { Http_imageUrl } from "./State.fs.js";

function bundeslandTag(bundesland) {
    return react.createElement("span", {
        className: "tag is-info is-light",
        title: bundesland.Bezeichnung,
    }, bundesland.Abkuerzung);
}

function bundeslaenderAnzeige(allBundeslaenderCount, bundeslaender) {
    if (isEmpty(bundeslaender)) {
        return react.createElement("span", {
            className: "tag is-light",
        }, "bundesweit");
    }
    else if ((allBundeslaenderCount > 0) && (length(bundeslaender) === allBundeslaenderCount)) {
        return react.createElement("span", {
            className: "tag is-light",
        }, "bundesweit");
    }
    else {
        const children_4 = [toArray(map(bundeslandTag, bundeslaender))];
        return react.createElement("div", {
            className: "tags",
        }, ...children_4);
    }
}

export function tableRow(allBundeslaenderCount, dispatch, navigateTo, news) {
    let children_6, children_8, children_16, children_10, children_12, children_14;
    const aktiv = news.Aktiv ? "" : "deaktiviert";
    const children_18 = [react.createElement("td", {}, news.Titel), (children_6 = [(news.AnzeigeConstraint === "") ? react.createElement("div", {}) : react.createElement("div", {}, news.AnzeigeConstraint), bundeslaenderAnzeige(allBundeslaenderCount, news.Bundeslaender)], react.createElement("td", {}, ...children_6)), (children_8 = [toString(news.Datum, "dd.MM.yyyy")], react.createElement("td", {}, ...children_8)), (children_16 = [(children_10 = [icon("fas fa-edit")], react.createElement("a", {
        onClick: (_arg) => {
            navigateTo(new Page(1, [news.Id]));
        },
        title: "bearbeiten",
    }, ...children_10)), news.Aktiv ? ((children_12 = [icon("fas fa-eye-slash")], react.createElement("a", {
        onClick: (_arg_1) => {
            dispatch(new Msg(6, [news.Id]));
        },
        title: "deaktivieren",
    }, ...children_12))) : ((children_14 = [icon("fas fa-eye")], react.createElement("a", {
        onClick: (_arg_2) => {
            dispatch(new Msg(5, [news.Id]));
        },
        title: "aktivieren",
    }, ...children_14)))], react.createElement("td", {}, ...children_16))];
    return react.createElement("tr", {
        className: aktiv,
    }, ...children_18);
}

export function table(allBundeslaenderCount, news, dispatch, navigateTo) {
    let children_10, children_8, children_12;
    const children_14 = [(children_10 = [(children_8 = [react.createElement("th", {}, "Titel"), react.createElement("th", {}, "nur für"), react.createElement("th", {}, "Gültig ab"), react.createElement("th", {}, "Aktionen")], react.createElement("tr", {}, ...children_8))], react.createElement("thead", {}, ...children_10)), (children_12 = map((news_1) => tableRow(allBundeslaenderCount, dispatch, navigateTo, news_1), news), react.createElement("tbody", {}, ...children_12))];
    return react.createElement("table", {
        className: "table table-striped responsive-table",
    }, ...children_14);
}

export function listPage(model, dispatch, navigateTo) {
    let children_38;
    let patternInput;
    const matchValue = model.Filter;
    patternInput = ((matchValue.tag === 1) ? ["is-outlined", "", "is-outlined", "is-outlined", "is-outlined", "is-outlined"] : ((matchValue.tag === 3) ? ["is-outlined", "is-outlined", "", "is-outlined", "is-outlined", "is-outlined"] : ((matchValue.tag === 2) ? ["is-outlined", "is-outlined", "is-outlined", "", "is-outlined", "is-outlined"] : ((matchValue.tag === 4) ? ["is-outlined", "is-outlined", "is-outlined", "is-outlined", "", "is-outlined"] : ((matchValue.tag === 5) ? ["is-outlined", "is-outlined", "is-outlined", "is-outlined", "is-outlined", ""] : ["", "is-outlined", "is-outlined", "is-outlined", "is-outlined", "is-outlined"])))));
    const children_40 = [(children_38 = toList(delay(() => {
        let children_36, children_34;
        return append(singleton((children_36 = [(children_34 = toList(delay(() => append(singleton(react.createElement("button", {
            className: "button is-link is-pulled-right is-small",
            onClick: (_arg) => {
                navigateTo(new Page(2, []));
            },
        }, "Neu")), delay(() => {
            let children_28, children_4, props_2, children_8, props_6, children_12, props_10, children_16, props_14, children_20, props_18, children_22, children_26, props_26;
            return append(singleton((children_28 = [(children_4 = [(props_2 = [new HTMLAttr(65, ["button is-link is-small is-rounded is-info " + patternInput[0]]), new DOMAttr(40, [(_arg_1) => {
                dispatch(new Msg(2, [new Filter(0, [])]));
            }])], react.createElement("button", keyValueList(props_2, 1), "alle"))], react.createElement("p", {
                className: "control",
            }, ...children_4)), (children_8 = [(props_6 = [new HTMLAttr(65, ["button is-link is-small is-rounded is-info " + patternInput[1]]), new DOMAttr(40, [(_arg_2) => {
                dispatch(new Msg(2, [new Filter(1, [])]));
            }])], react.createElement("button", keyValueList(props_6, 1), "nur Pflege"))], react.createElement("p", {
                className: "control",
            }, ...children_8)), (children_12 = [(props_10 = [new HTMLAttr(65, ["button is-link is-small is-rounded is-info " + patternInput[2]]), new DOMAttr(40, [(_arg_3) => {
                dispatch(new Msg(2, [new Filter(3, [])]));
            }])], react.createElement("button", keyValueList(props_10, 1), "nur BFS Plus"))], react.createElement("p", {
                className: "control",
            }, ...children_12)), (children_16 = [(props_14 = [new HTMLAttr(65, ["button is-link is-small is-rounded is-info " + patternInput[3]]), new DOMAttr(40, [(_arg_4) => {
                dispatch(new Msg(2, [new Filter(2, [])]));
            }])], react.createElement("button", keyValueList(props_14, 1), "nur Therapie"))], react.createElement("p", {
                className: "control",
            }, ...children_16)), (children_20 = [(props_18 = [new HTMLAttr(65, ["button is-link is-small is-rounded is-info " + patternInput[4]]), new DOMAttr(40, [(_arg_5) => {
                dispatch(new Msg(2, [new Filter(4, [])]));
            }])], react.createElement("button", keyValueList(props_18, 1), "nur Jugendhilfe"))], react.createElement("p", {
                className: "control",
            }, ...children_20)), (children_22 = [react.createElement("input", {
                className: "input is-info is-small",
                type: "text",
                placeholder: "Kundennummer",
                value: model.KundennummernFilterText,
                onChange: (ev) => {
                    dispatch(new Msg(3, [ev.target.value]));
                },
                onKeyDown: (e) => {
                    if (e.key === "Enter") {
                        dispatch(new Msg(4, []));
                    }
                },
            })], react.createElement("div", {
                className: "control",
            }, ...children_22)), (children_26 = [(props_26 = [new HTMLAttr(65, ["button is-info is-small is-rounded " + patternInput[5]]), new DOMAttr(40, [(_arg_6) => {
                dispatch(new Msg(4, []));
            }]), new HTMLAttr(79, [!model.KundennummernFilterEnabeld])], react.createElement("a", keyValueList(props_26, 1), "nur eine Kundennummer"))], react.createElement("div", {
                className: "control",
            }, ...children_26))], react.createElement("div", {
                className: "field has-addons",
            }, ...children_28))), delay(() => {
                let matchValue_1;
                return singleton((matchValue_1 = model.News, (matchValue_1.tag === 1) ? spinner : ((matchValue_1.tag === 2) ? errorMsg("Fehler beim Laden der News!") : ((matchValue_1.tag === 3) ? (equals(matchValue_1.fields[0].Items, empty()) ? react.createElement("div", {}, "Keine News vorhanden") : table(length(model.AllBundeslaender), matchValue_1.fields[0].Items, dispatch, navigateTo)) : react.createElement("div", {})))));
            }));
        })))), react.createElement("div", {
            className: "card-body",
        }, ...children_34))], react.createElement("div", {
            className: "flat-card profile-info-card is-auto",
        }, ...children_36))), delay(() => {
            const matchValue_2 = model.News;
            if (matchValue_2.tag === 3) {
                return singleton(pagination(matchValue_2.fields[0], (page) => {
                    navigateTo(new Page(0, [page]));
                }));
            }
            else {
                return empty_1();
            }
        }));
    })), react.createElement("div", {
        className: "column is-12",
    }, ...children_38))];
    return react.createElement("div", {
        className: "columns is-multiline",
    }, ...children_40);
}

export function kundennummerTag(dispatch, kdnr) {
    let children, copyOfStruct;
    const children_4 = [(children = [(copyOfStruct = kdnr, int32ToString(copyOfStruct))], react.createElement("span", {
        className: "tag is-info",
    }, ...children)), react.createElement("a", {
        className: "tag is-delete is-danger",
        onClick: (_arg) => {
            dispatch(new Msg(24, [kdnr]));
        },
    })];
    return react.createElement("div", {
        className: "tags has-addons",
    }, ...children_4);
}

export function editBox(model, dispatch, navigateTo) {
    let children_74, children_4, children_2, children_72, children_10, children_8, children_6, children_24, children_14, children_12, children_22, children_20, children_18, children_46, children_26, children_44, children_42, children_40, children_36, children_30, children_34, props_34, children_38, children_52, children_50, children_48, children_58, children_56, children_54, children_70, children_68, children_62, props_62, children_66, children_64;
    const isLoading = model.Sending ? " is-loading" : "";
    return column(singleton_1(new Option(0, [new Screen(0, []), new ISize(10, [])])), ofArray([(children_74 = [(children_4 = [(children_2 = [react.createElement("b", {}, "News bearbeiten")], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_72 = [(children_10 = [(children_8 = [(children_6 = [validatedTextBox((arg) => {
        dispatch(new Msg(17, [arg]));
    })("Titel")("Titel")("")(model.Titel)], react.createElement("div", {
        className: "info-block",
    }, ...children_6))], react.createElement("div", {
        className: "column is-12",
    }, ...children_8))], react.createElement("div", {
        className: "columns",
    }, ...children_10)), (children_24 = [(children_14 = [(children_12 = [validatedDatePicker((tupledArg) => (new Msg(19, [tupledArg[0], tupledArg[1]])), "Gültig ab", model.GueltigAb, dispatch)], react.createElement("div", {
        className: "info-block",
    }, ...children_12))], react.createElement("div", {
        className: "column is-8",
    }, ...children_14)), (children_22 = [(children_20 = [(children_18 = [react.createElement("label", {
        className: "label",
    }, "Aktiv"), checkbox(model.Aktiv, (b) => {
        dispatch(new Msg(20, [b]));
    }, "")], react.createElement("div", {
        className: "field",
    }, ...children_18))], react.createElement("div", {
        className: "info-block",
    }, ...children_20))], react.createElement("div", {
        className: "column is-4",
    }, ...children_22))], react.createElement("div", {
        className: "columns",
    }, ...children_24)), (children_46 = [(children_26 = [Selector(model.KundenTyp, (kundentyp) => {
        dispatch(new Msg(21, [kundentyp]));
    })], react.createElement("div", {
        className: "column is-4",
    }, ...children_26)), (children_44 = [(children_42 = [(children_40 = [react.createElement("label", {
        className: "label",
    }, "Kundennummern"), (children_36 = [(children_30 = [react.createElement("input", {
        className: "input",
        type: "text",
        placeholder: "hinzufügen",
        value: model.KundennummernAddText,
        onChange: (ev) => {
            dispatch(new Msg(22, [ev.target.value]));
        },
        onKeyDown: (e) => {
            if (e.key === "Enter") {
                dispatch(new Msg(23, []));
            }
        },
    })], react.createElement("div", {
        className: "control",
    }, ...children_30)), (children_34 = [(props_34 = [new HTMLAttr(65, ["button is-info"]), new DOMAttr(40, [(_arg) => {
        dispatch(new Msg(23, []));
    }]), new HTMLAttr(79, [!model.KundennummernAddEnabeld])], react.createElement("a", keyValueList(props_34, 1), "+"))], react.createElement("div", {
        className: "control",
    }, ...children_34))], react.createElement("div", {
        className: "field has-addons",
    }, ...children_36)), (children_38 = [toArray(map((kdnr) => kundennummerTag(dispatch, kdnr), model.Kundennummern))], react.createElement("div", {
        className: "taglist",
    }, ...children_38))], react.createElement("div", {
        className: "field",
    }, ...children_40))], react.createElement("div", {
        className: "info-block",
    }, ...children_42))], react.createElement("div", {
        className: "column is-8",
    }, ...children_44))], react.createElement("div", {
        className: "columns",
    }, ...children_46)), (children_52 = [(children_50 = [(children_48 = [MultiSelector(model.AllBundeslaender, model.Bundeslaender, (id) => {
        dispatch(new Msg(15, [id]));
    }, () => {
        dispatch(new Msg(16, []));
    })], react.createElement("div", {
        className: "info-block",
    }, ...children_48))], react.createElement("div", {
        className: "column is-12",
    }, ...children_50))], react.createElement("div", {
        className: "columns",
    }, ...children_52)), (children_58 = [(children_56 = [(children_54 = [validatedTextarea((arg_1) => {
        dispatch(new Msg(18, [arg_1]));
    }, "Text", "Text", "", "is-big", model.Text)], react.createElement("div", {
        className: "info-block",
    }, ...children_54))], react.createElement("div", {
        className: "column is-12",
    }, ...children_56))], react.createElement("div", {
        className: "columns",
    }, ...children_58)), (children_70 = [(children_68 = [(children_62 = [(props_62 = [new HTMLAttr(65, ["button is-link" + isLoading]), new HTMLAttr(79, [!NewsModel__get_CanSubmit(model)]), new DOMAttr(40, [(_arg_1) => {
        dispatch(new Msg(28, []));
    }])], react.createElement("button", keyValueList(props_62, 1), "Speichern"))], react.createElement("div", {
        className: "info-block is-pulled-right",
    }, ...children_62)), (children_66 = [(children_64 = [model.IsDirty ? "Abbrechen" : "Zurück"], react.createElement("button", {
        className: "button is-danger is-link",
        onClick: (_arg_2) => {
            navigateTo(new Page(0, [model.BackToPage]));
        },
    }, ...children_64))], react.createElement("div", {
        className: "info-block",
    }, ...children_66))], react.createElement("div", {
        className: "column is-12",
    }, ...children_68))], react.createElement("div", {
        className: "columns",
    }, ...children_70))], react.createElement("div", {
        className: "card-body",
    }, ...children_72))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto",
    }, ...children_74)), adminImageUploadBox(model.Id, model.HasImage, (id_1) => Http_imageUrl(model.ImageUpdateTrigger, id_1), new Msg(25, []), (Item_6) => (new Msg(26, [Item_6])), dispatch, "Bild", "Bitte speichern Sie die neue News bevor Sie ein Bild hochladen.")]));
}

export function previewBox(model) {
    let children_10, children_4, children_2, children_8, props_6;
    return column(singleton_1(new Option(0, [new Screen(0, []), new ISize(10, [])])), singleton_1((children_10 = [[(children_4 = [(children_2 = [react.createElement("b", {}, model.Titel.Value)], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_8 = [(props_6 = [new HTMLAttr(65, ["content"]), new DOMAttr(0, [new DangerousHtml(model.TextAsHtml)])], react.createElement("div", keyValueList(props_6, 1)))], react.createElement("div", {
        className: "card-body",
    }, ...children_8))]], react.createElement("div", {
        className: "flat-card profile-info-card is-auto",
    }, ...children_10))));
}

export function editPage(model, dispatch, navigateTo) {
    const children = [editBox(model, dispatch, navigateTo), previewBox(model)];
    return react.createElement("div", {
        className: "columns is-multiline",
    }, ...children);
}

export function view(model, dispatch, navigateTo) {
    if (model.tag === 1) {
        return editPage(model.fields[0], dispatch, (arg_1) => {
            navigateTo(arg_1);
        });
    }
    else {
        return listPage(model.fields[0], dispatch, (arg) => {
            navigateTo(arg);
        });
    }
}

//# sourceMappingURL=View.fs.js.map
